/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HorecaReceptionBellIcon16Solid = forwardRef('HorecaReceptionBellIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.5.5a.5.5 0 0 0-1 0v.75a.5.5 0 0 0 1 0V.5Z" }),
        React.createElement("path", { d: "M11.896 1.396a.5.5 0 0 1 .708.708l-.75.75a.5.5 0 0 1-.708-.708l.75-.75Z" }),
        React.createElement("path", { d: "M6.5 3a.75.75 0 0 0 0 1.5h.75v1.296c-2.91.362-5.013 2.807-5.231 5.704-.021.275.205.5.481.5h11a.472.472 0 0 0 .481-.5c-.218-2.897-2.322-5.342-5.231-5.704V4.5h.75a.75.75 0 0 0 0-1.5h-3Z" }),
        React.createElement("path", { d: "M.75 14a1 1 0 0 1 1-1h12.5a1 1 0 1 1 0 2H1.75a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M13.5 6h1a.5.5 0 0 0 0-1h-1a.5.5 0 1 0 0 1Z" }),
        React.createElement("path", { d: "M3.396 1.396a.5.5 0 0 1 .708 0l.75.75a.5.5 0 1 1-.708.708l-.75-.75a.5.5 0 0 1 0-.708Z" }),
        React.createElement("path", { d: "M1.5 6h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1Z" })));
});
